/**
 * Enum correspondente a origem do acordo.
 */
export enum TipoOrigemAcordoEnum {

    CONGENERES          = 1,
    LOCADORAS           = 2,
    TERCEIROS           = 3,
    INQUILINOS          = 4,
    OUTROS              = 5,
    OCUPANTE            = 7,
    FRANQUIA            = 8,
    EXCEDENTE_DE_VERBA  = 9
}
